import useAccount from "@hooks/useAccount"


import { useTranslation } from "react-i18next"
import useClientConfig from "./useClientConfig"

interface ClientTranslationConfig {
  translate: (value: string) => string
  translationReady: () => boolean
}


const useClientTranslation = (): ClientTranslationConfig => {

  const { getClientName } = useClientConfig()
  const commonFileName = 'common'
  const clientFileName = 'common-' + getClientName()
  const { t } = useTranslation([clientFileName, commonFileName])
  const { ready } = useTranslation([clientFileName, commonFileName], { useSuspense: false, })

  const translate = (value: string): string => {
    //console.log('Translating ' + value)
    //console.log(commonFileName)
    //console.log(clientFileName)
    //console.log(t(value, { ns: commonFileName }))

    if (value !== undefined && value.trim().includes(' ')) {
      return value
    }

    if (t(value, { ns: clientFileName }) === value) {
      return t(value, { ns: commonFileName })
    }

    return t(value, { ns: clientFileName })
  }

  const translationReady = (): boolean => {
    return ready
  }

  return {
    translate,
    translationReady
  }
}

export default useClientTranslation
